<template>
  <div class="bg-white rounded-2xl shadow-sm border border-gray-100 p-5 w-full">
    <h2 class="text-base font-medium text-gray-700 mb-4">Répartition des projets</h2>
    <VueApexCharts type="donut" height="300" :options="chartOptions" :series="series" />
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue"
import VueApexCharts from "vue3-apexcharts"
import axios from "axios"

// ✅ Données réactives
const series = ref([])
const chartOptions = ref({
  labels: [],
  colors: ["#10b981", "#3b82f6", "#f87171"], // Vert, Bleu, Rouge
  legend: {
    position: "bottom",
    labels: { colors: "#6b7280" },
  },
  dataLabels: {
    enabled: true,
    formatter: (val, opts) => {
      const value = opts.w.config.series[opts.seriesIndex]
      return `${value} projets`
    },
  },
  tooltip: { y: { formatter: (value) => `${value} projets` } },
  plotOptions: {
    pie: {
      donut: {
        size: "70%",
        labels: {
          show: true,
          total: {
            show: true,
            label: "Total",
            formatter: (w) => {
              const sum = w.globals.seriesTotals.reduce((a, b) => a + b, 0)
              return `${sum} projets`
            },
          },
        },
      },
    },
  },
})

// ✅ Fonction pour récupérer les stats depuis le backend
const fetchProjetStats = async () => {
  try {
    const token = localStorage.getItem("token")
    const res = await axios.get("https://datafuseweb-95a5588f8542.herokuapp.com/api/clients/dashboard/projets/statut", {
      headers: { Authorization: `Bearer ${token}` },
    })

    // Mettre à jour les données réactives
    series.value = res.data.series
    chartOptions.value = {
      ...chartOptions.value,
      labels: res.data.labels,
    }

    console.log("Stats projets reçues :", res.data)
  } catch (err) {
    console.error("Erreur récupération stats projets :", err)
  }
}

onMounted(() => fetchProjetStats())
</script>
